/**
 * Copyright (c) 2025 Adaptive Chaos Labs, LLC
 * All rights reserved.
 */

/**
 * **The `inferred` mark** (`D40`, `1f-iii`) — one rendering for the row and the legend, so the two
 * cannot come to look different. Neutral, because a grade is not a severity (`LP10`).
 */

import React from 'react';
import { Box } from '@chakra-ui/react';

import { INFERRED_DECLARATION_LABEL } from './provenance-presentation';

export const EvidenceMark: React.FC<{ focusable: boolean }> = ({ focusable }) => (
  <Box
    as="span"
    {...(focusable ? { tabIndex: 0 } : {})}
    fontSize="10px"
    px={1.5}
    borderRadius="sm"
    borderWidth="1px"
    borderColor="border.default"
    color="fg.muted"
    whiteSpace="nowrap"
    data-mark="inferred-declaration"
  >
    {INFERRED_DECLARATION_LABEL}
  </Box>
);
